<template>
   <div class="order">
   	<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
	<title>填写报名信息-以诺教育</title>
   	<headTop></headTop>
   		<div class="orderA">
   			<div class="cost">
   				<p class="detail">费用明细</p>
   				<ul class="detailText">
   					<li v-if="zhOrderList.price_type=='市场价'?false:true">市场价<span>￥{{zhOrderList.old_price}}</span></li>
   					<li>{{zhOrderList.price_type}}<span>￥{{zhOrderList.market_price}}</span></li>
   					<li>报名人数<span>×{{number}}</span></li>
   					<li v-show="coupon">优惠券<span>{{zhOrderList.couponprice}}</span></li>
   					<li v-show="scholarship">抵扣奖学金<span>￥{{zhOrderList.scholarship}}</span></li>
   					<li>学费抵扣<b class="integral">(积分-{{zhOrderList.integral}})</b><span>￥{{zhOrderList.tuitionsum}}</span></li>
   				</ul>
   				<p class="money1">实付金额<span>￥{{zhOrderList.price}}</span></p>
   			</div>
   			<div class="flow"></div>
   			<div class="orderHader">
   				<div class="headerLeft"><img :src="img"/></div>
   				<div class="headerRight" v-for="item in list">
   				    <h1 class="article">{{item.name}}</h1>
   				    <p class="address">开班地点：{{item.address}}</p>
   				    <p class="starTime">开班时间：{{item.classes_begin}}至{{item.classes_end}}</p>
   				</div>
   			</div>
   			<div class="content">
   				<p class="student"><b>学员信息</b><span class="bitian">(必填)</span>&nbsp;&nbsp;&nbsp;已报名人数：<span class="renshuo"> {{number}} </span>人
            <!-- <span class="yes-up" @click="orderList=!orderList"><img src="../../assets/yes-up.png"><span>添加报名人</span></span> -->
          </p>
   			<div id="add">
          <ul class="info-choice" v-if="studentsList.length!==0">
            <li v-for="(item,index) in studentsList" :class="[item.display?'':'ceshi']" @click="infoChoice(index)">{{item.name}}</li>
          </ul>
          <!-- <div class="info-message">
            <div class="delates">
              <hr>
            </div>
            <div class="details">
              <span>张毅</span>
              <span>133****1333</span>
            </div>
          </div>
          <div class="info-message">
            <div class="delates">
              <hr>
            </div>
            <div class="details">
              <span>李毅</span>
              <span>133****1333</span>
            </div>
          </div> -->
   			    <div class="info" v-for="item in ceshi">
              <div class="people"><span>{{item}}</span></div>
              <p><span>姓名</span><input type="text" class="addName"/><i class="error"></i></p>
              <p v-if="pinyin"><span>护照英文姓</span><input type="text" class="zhFight"/><span class="zhPin">护照英文名</span><input type="text" class="zhFight zhSecond_name"/><i class="error1" style="margin-left:0px"></i></p>
              <p class="zhSpecial"><span class="zhP">证件号码</span><select class="Certificates"><option selected="selected">身份证</option><option>护照</option><option>台胞证</option><option>回乡证</option></select><input type="text" class="identity" /><i class="error"></i></p>
              <p v-if="zhOverseas" class="oversea"><span>护照号</span><input type="text" class="zhPassportHZ"/><i class="error"></i></p>
              <p class="zhSpecial" v-if="zhOverseas"><span class="zhP">护照有效期</span>
                 <!-- <input type="text" class="passport zhPassport"  placeholder="2020-12-12"/> -->
                 <Col span="8">
                     <DatePicker type="date" placeholder="请选择护照有效期" style="width: 200px"></DatePicker>
                 </Col>
                 <i class="error"></i>
              </p>
              <p><span>手机</span><input type="text" class="phone"/><i class="error"></i></p>
              <p class="zhSpecial renzhi" v-if="interval==1?true:false"><span class="zhP">任职机构</span><input type="text" class="passport zhPassport1"/><i class="error"></i></p>
              <p class="zhiwu" v-if="interval==1?true:false"><span>职务</span><input type="text" class="passport zhJigou"/><i class="error"></i></p>
              <p><input class="infoId" type="hidden"></p>
              <div class="delate" ><span>－</span>删除</div>
            </div>

          </div>
   				<div class="add">
   					<div class="addstu"><span>＋</span>添加学员</div>
   					<p>超过5个学员报名建议联系客服</p>
   				</div>
   				<div class="kong"></div>
   				<div class="contact">
   					<p class="contactText">让我们联系到您<span class="bitian">(必填)</span><span class="yes-up" @click="contactsList=!contactsList"><img src="../../assets/yes-up.png"><span>更换联系人</span></span></p>
   					<p class="tt1"><span>姓名</span><input type="text" class="addName" v-model="linkmanLis.name"/><i class="error"></i></p>
   					<p class="tt2"><span>手机号</span><input type="text" class="phone" v-model="linkmanLis.phone"/><i class="error"></i><input type="hidden" class="contactId"  :value="linkmanLis?linkmanLis.id:''"/></p>
            <p class="tt3"><i class="error"></i></p>
   				</div>
   				<!--<div class="chit">
   					<p class="chitCon">推荐人信息 <span class="bitian">(选填)</span></p>
            <p class="chitNum"><span>姓名</span><input type="text" class="chitPh"/></p>
   					<p class="chitNum"><span>手机号</span><input type="text" class="chitPh"/></p>
   				</div>-->
   				<div class="discount" v-show="discount">
   					<p class="discountText">优惠信息</p>
   					<div class="couponValue">
   						<div v-show="couponValue">
   					<p class="voucher">优惠券<span>（部分优惠不能叠加使用）</span></p>
						<div class="couponPicture" v-for="(coupon,index) in conpons.filter(coupon=>coupon.useaccess==1)">
				     			<div class="VouchersLeft1" @click="selected(coupon,index)">
				     				<div class="amountNumbert"><span>{{coupon.price}}</span> 元<i>{{coupon.name}}</i></div>
				     				<p class="moneyTime">满{{coupon.condition}}可以使用</p>
				     				<p class="moneyTime">有效期：{{coupon.time_out}}</p>
				     			</div>
				     			<div class="Marquee" >
				     				<div class="CancelCheck" @click.stop="quxiao(coupon,index)">取消勾选</div>
				     			</div>
				     			<div class="mask"></div>
						</div>
						<div class="couponPicture1" v-for="coupon in conpons.filter(coupon=>coupon.useaccess==0)">
				     			<div class="VouchersLeft1">
				     				<div class="amountNumbert Voucher"><span>{{coupon.price}}</span> 元<i>{{coupon.name}}</i></div>
				     				<p class="moneyTime Voucher">满{{coupon.condition}}可以使用</p>
				     				<p class="moneyTime Voucher">有效期：{{coupon.time_out}}</p>
				     			</div>
						</div>
						<div class="kong"></div>
   					<ul class="burse">
   						<li><div class="jiang"><Icon type="checkmark-round" v-if="zhtoggle"></Icon></div></li>
   						<li>使用奖学金抵扣</li>
   						<li><div class="qian">{{zhOrderList.scholarship_n}}</div></li>
   					</ul>
            <div class="shuo" style="margin-left:40px;margin-bottom:20px">
              你共有 {{zhOrderList.max_scholarship}} 元奖学金，本单最高可用 {{zhOrderList.scholarship_n}} 元奖学金抵扣 {{zhOrderList.scholarship_n}} 元
            </div>
   					</div>
   					<ul class="burse">
   						<li><div class="xue" @click="xuefei"><Icon type="checkmark-round" v-if="zhtoggleX"></Icon></div></li>
   						<li>使用学费抵扣&nbsp;&nbsp;&nbsp;</li>
   						<li><div class="qian">{{zhOrderList.tuitionsum}}</div></li>
   						<li class="shuo">你共有 {{zhOrderList.tuitionsum_all}} 元学费（含积分{{zhOrderList.integral_all}}）</li>
   					</ul>
   					<div class="kong"></div>
   				</div>
   				</div>
   				<div class="agree">
   					<ul class="read">
   						<li><div class="yue"><Icon type="checkmark-round" class="chang" v-if="zhtoggle1"></Icon></div></li>
   						<li>我已阅读并同意<a @click="zhxieyi" class="zhxieyi">《报名须知》</a></li>
   						<li class="paid">实付金额：<span>￥{{zhOrderList.price<0?0.00:zhOrderList.price}}</span></li>
   						<li><a @click="zhCommit" class="zhCommit" :disabled="zanting">立即申请</a></li>
   					</ul>
   				</div>
   			</div>

   		</div>
   		<Bottom></Bottom>
      <List v-if="orderList || contactsList" :order-list="orderList" :contacts-list="contactsList" v-on:linkman="linkman($event)" v-on:cha="cha($event)"></List>
   </div>
</template>

<script>
	import headTop from "../headTop/headTop"
  import Bottom from "../Bottom/Bottom"
  import List from "./list"
	export default {
		name:"order",
		components:{headTop,Bottom,List},
		data(){
			return{
        studentsList:[],
			  url:'',
			  list:[],
        orderList:false,
        contactsList:false,
        linkmanLis:{
          name:'',
          phone:'',
          id:''
        },
        ceshi:[1],
			  banner:[],
			  img:'',
	        zhtoggle:true,
	        zhtoggle1:true,
	        number:1,
	        count:0,
	        count1:1,
	        id:this.$route.params.id,
	        zhOverseas:false,
	        zhOrderList:{},
	        zhJudge:false,
	        xin:sessionStorage.getItem("xin"),
	      value1: '',
	      scholarship:true,
	      coupon:true,
	      couponValue:true,
	      discount:true,
	      conpons:[],
	      conid:[],
	      pinyin:false,
	      zanting:false,
	      zhtoggleX:false,
	      interval:0,

			}
		},
		methods:{
        cha(msg){
          this.orderList = msg
          this.contactsList = msg
        },
        linkman(msg){
          this.linkmanLis=msg
        },
        infoChoice(index){
          this.studentsList[index].display = !this.studentsList[index].display
          if(this.studentsList[index].display){
            if(this.number>=5){
              this.studentsList[index].display = !this.studentsList[index].display
              return
            }
           this.addstudents(index)
          }else{
            if($('.info').length === 1){
              $('.info').eq(0).children().children('.addName')?$('.info').eq(0).children().children('.addName').val(''):''
              $('.info').eq(0).children().children('.identity')?$('.info').eq(0).children().children('.identity').val(''):''
              $('.info').eq(0).children().children('.zhPassportHZ')?$('.info').eq(0).children().children('.zhPassportHZ').val(''):''
              $('.ivu-input').eq(0)?$('.ivu-input').eq(0).val(''):''
              $('.info').eq(0).children().children('.phone')?$('.info').eq(0).children().children('.phone').val(''):''
              $('.info').eq(0).children().children('.zhPassport1')?$('.info').eq(0).children().children('.zhPassport1').val(''):''
              $('.info').eq(0).children().children('.zhJigou')?$('.info').eq(0).children().children('.zhJigou').val(''):''
              $('.info').eq(0).children().children('.zhFight')?$('.info').eq(0).children().children('.zhFight').val(''):''
              $('.info').eq(0).children().children('.zhSecond_name')?$('.info').eq(0).children().children('.zhSecond_name').val(''):''
              $('.info').eq(0).children().children('.infoId')?$('.info').eq(0).children().children('.infoId').val(''):''
            }else{
              for(let i=0;i<$('.info').length;i++){
                let infoId = $('.info').eq(i).children().children('.infoId').val()
                if(infoId==''){

                }else{
                  if(this.studentsList[index].id === parseInt(infoId)){
                    $(".delate").eq(i).click()
                  }
                }
              }
            }


          }

        },
        addstudents(index){
          var infoArray = []
          for(var j=0;j<$('.info').length;j++){
            infoArray.push({
              "name":$('.info').eq(j).children().children('.addName').val(),
              "identity":$('.info').eq(j).children().children('.identity').val(),
              "passport":$('.info').eq(j).children().children('.zhPassportHZ')?$('.info').eq(j).children().children('.zhPassportHZ').val():'',
              "validity_time":$('.ivu-input').eq(j)?$('.ivu-input').eq(j).val():'',
              "mobile":$('.info').eq(j).children().children('.phone').val(),
              "office_space":$('.info').eq(j).children().children('.zhPassport1').val(),
              "job_title":$('.info').eq(j).children().children('.zhJigou').val(),
              "first_name":$('.info').eq(j).children().children('.zhFight').val(),
              "second_name":$('.info').eq(j).children().children('.zhSecond_name').val(),
              "id":$('.info').eq(j).children().children('.infoId').val()
              // "identity_type":$(".Certificates option:selected").eq(j).index(),
            })
          }
          var infoIndex=0;
          this.infoRecursion(infoIndex,infoArray,index)
        },
        infoRecursion(infoIndex,infoArray,index){
          for(var j=infoIndex;j<infoArray.length;j++){
            var estimateArray = []
            for(var estimatePrice in infoArray[j]){
              if(infoArray[j][estimatePrice] === undefined){
              }else{
                if(infoArray[j][estimatePrice].length===0){
                  estimateArray.push(true)
                }else{
                  estimateArray.push(false)
                }
              }
            }
            var estimatelength=estimateArray.length
            var estimateLength = 0
            for(var i = 0;i<estimateArray.length;i++){
              if(estimateArray[i]){
                estimateLength ++
              }
            }
            infoIndex++
            if(estimateLength=== estimatelength){
              if(this.studentsList[index].identity_type===1){
                	$(".oversea").eq(j).css({"display":"none"})
              }
              $('.info').eq(j).children().children('.addName')?$('.info').eq(j).children().children('.addName').val(this.studentsList[index].name!=='undefined'?this.studentsList[index].name:''):''
              $('.info').eq(j).children().children('.identity')?$('.info').eq(j).children().children('.identity').val(this.studentsList[index].identity!=='undefined'?this.studentsList[index].identity:''):''
              $('.info').eq(j).children().children('.Certificates')?$('.info').eq(j).children().children('.Certificates').get(0).selectedIndex=(this.studentsList[index].identity_type!=='undefined'?this.studentsList[index].identity_type:''):''
              $('.info').eq(j).children().children('.zhPassportHZ')?$('.info').eq(j).children().children('.zhPassportHZ').val(this.studentsList[index].passport!=='undefined'?this.studentsList[index].passport:''):''
              $('.ivu-input').eq(j)?$('.ivu-input').eq(j).val(this.studentsList[index].validity_time!=='undefined'?this.studentsList[index].validity_time:''):''
              $('.info').eq(j).children().children('.phone')?$('.info').eq(j).children().children('.phone').val(this.studentsList[index].mobile!=='undefined'?this.studentsList[index].mobile:''):''
              $('.info').eq(j).children().children('.zhPassport1')?$('.info').eq(j).children().children('.zhPassport1').val(this.studentsList[index].office_space!=='undefined'?this.studentsList[index].office_space:''):''
              $('.info').eq(j).children().children('.zhJigou')?$('.info').eq(j).children().children('.zhJigou').val(this.studentsList[index].job_title!=='undefined'?this.studentsList[index].job_title:''):''
              $('.info').eq(j).children().children('.zhFight')?$('.info').eq(j).children().children('.zhFight').val(this.studentsList[index].first_name!=='undefined'?this.studentsList[index].first_name:''):''
              $('.info').eq(j).children().children('.zhSecond_name')?$('.info').eq(j).children().children('.zhSecond_name').val(this.studentsList[index].second_name!=='undefined'?this.studentsList[index].second_name:''):''
              $('.info').eq(j).children().children('.infoId')?$('.info').eq(j).children().children('.infoId').val(this.studentsList[index].id!=='undefined'?this.studentsList[index].id:''):''
              return
            }else{
              if(infoIndex>=infoArray.length){
                $(".add").click()
                setTimeout(()=>{
                  if(this.studentsList[index].identity_type===1){
                      $(".oversea").eq($('.info').length-1).css({"display":"none"})
                  }
                  $('.info').eq($('.info').length-1).children().children('.addName')?$('.info').eq($('.info').length-1).children().children('.addName').val(this.studentsList[index].name!=='undefined'?this.studentsList[index].name:''):''
                  $('.info').eq($('.info').length-1).children().children('.identity')?$('.info').eq($('.info').length-1).children().children('.identity').val(this.studentsList[index].identity!=='undefined'?this.studentsList[index].identity:''):''
                  $('.info').eq($('.info').length-1).children().children('.Certificates')?$('.info').eq($('.info').length-1).children().children('.Certificates').get(0).selectedIndex=(this.studentsList[index].identity_type!=='undefined'?this.studentsList[index].identity_type:''):''
                  $('.info').eq($('.info').length-1).children().children('.zhPassportHZ')?$('.info').eq($('.info').length-1).children().children('.zhPassportHZ').val(this.studentsList[index].passport!=='undefined'?this.studentsList[index].passport:''):''
                  $('.ivu-input').eq($('.info').length-1)?$('.ivu-input').eq($('.info').length-1).val(this.studentsList[index].validity_time!=='undefined'?this.studentsList[index].validity_time:''):''
                  $('.info').eq($('.info').length-1).children().children('.phone')?$('.info').eq($('.info').length-1).children().children('.phone').val(this.studentsList[index].mobile!=='undefined'?this.studentsList[index].mobile:''):''
                  $('.info').eq($('.info').length-1).children().children('.zhPassport1')?$('.info').eq($('.info').length-1).children().children('.zhPassport1').val(this.studentsList[index].office_space!=='undefined'?this.studentsList[index].office_space:''):''
                  $('.info').eq($('.info').length-1).children().children('.zhJigou')?$('.info').eq($('.info').length-1).children().children('.zhJigou').val(this.studentsList[index].job_title!=='undefined'?this.studentsList[index].job_title:''):''
                  $('.info').eq($('.info').length-1).children().children('.zhFight')?$('.info').eq($('.info').length-1).children().children('.zhFight').val(this.studentsList[index].first_name!=='undefined'?this.studentsList[index].first_name:''):''
                  $('.info').eq($('.info').length-1).children().children('.zhSecond_name')?$('.info').eq($('.info').length-1).children().children('.zhSecond_name').val(this.studentsList[index].second_name!=='undefined'?this.studentsList[index].second_name:''):''
                  $('.info').eq($('.info').length-1).children().children('.infoId')?$('.info').eq($('.info').length-1).children().children('.infoId').val(this.studentsList[index].id!=='undefined'?this.studentsList[index].id:''):''
                },0)

                return
              }else{
                this.infoRecursion(infoIndex,infoArray,index)
                return
              }
            }
          }
        },
        zhCommit(){
        var that=this
             if(that.zhtoggle1==true){
                     var a=true;
                     var b=true;
                     var c=true;
                     var d=true;
                     var e=true;
                     var f=true;
                      for(var i=0;i<$('.addName').length;i++){
                        if(!( /^[\u4e00-\u9fa5]{2,5}$/.test($('.addName').eq(i).val()))){
                          a = false;
                        }
                      }
                      if(a == true){
                      	for(let j=0;j<$(".Certificates").length;j++){
                      		if($(".Certificates option:selected").eq(j).val()=='身份证'){
		                           if(!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test($('.identity').eq(j).val()))){
		                             b = false;
		                          }
                      		}else{
                      			if($('.identity').eq(j).val()==''){
                      				b=false;
                      			}
                      		}
                      	}
                         if(b == true){
                            for(var i=0;i<$('.phone').length;i++){
                                if(!(/^\d{11}$/.test($('.phone').eq(i).val()))){
                                  c = false;
                                }
                              }
                              if(c == true){
                                for(var i=0;i<$('.passport').length;i++){
                                	if(that.interval==1){
                                		if(($('.passport').eq(i).val()==='')&&$('.passport').eq(i)){
                                   d = false;
                                  }
                                	}
                                }
                                if(d == true){
                                  for(var i=0;i<$('.ivu-input').length;i++){
                                    if(($('.ivu-input').eq(i).val()==='')&&$('.ivu-input').eq(i)){
                                      e = false;
                                    }
                                  }
                                	for(var i=0;i<$('.Certificates').length;i++){
                                		if($(".Certificates").eq(i).val()!=="护照"){
                                			if(($('.zhPassportHZ').eq(i).val()==='')&&$('.zhPassportHZ').eq(i)){
                                      		e = false;
                                    }
                                		}
                                }
                                if(e == true){
                                  for(var i=0;i<$('.zhFight').length;i++){
                                    if(($('.zhFight').eq(i).val()==='')&&$('.zhFight').eq(i)){
                                      f = false;
                                    }
                                  }if(f == true){
                                    var contactName = $('.tt1').children('.addName').val();
                                    var contactPhone = $('.tt2').children('.phone').val();
                                    var contact_id = $('.tt2').children('.contactId').val();
                                    var chitList = [];
                                    var zhToken = localStorage.getItem('token');
                                    for(var j=0;j<$('.info').length;j++){
                                      chitList.push({
                                        "name":$('.info').eq(j).children().children('.addName').val(),
                                        "identity":$('.info').eq(j).children().children('.identity')?$('.info').eq(j).children().children('.identity').val():'',
                                        "passport":$('.info').eq(j).children().children('.zhPassportHZ')?$('.info').eq(j).children().children('.zhPassportHZ').val():'',
                                        "validity_time":$('.ivu-input').eq(j)?$('.ivu-input').eq(j).val():'',
                                        "mobile":$('.info').eq(j).children().children('.phone')?$('.info').eq(j).children().children('.phone').val():'',
                                        "office_space":$('.info').eq(j).children().children('.zhPassport1')?$('.info').eq(j).children().children('.zhPassport1').val():'',
                                        "job_title":$('.info').eq(j).children().children('.zhJigou')?$('.info').eq(j).children().children('.zhJigou').val():'',
                                        "first_name":$('.info').eq(j).children().children('.zhFight')?$('.info').eq(j).children().children('.zhFight').val():'',
                                        "second_name":$('.info').eq(j).children().children('.zhSecond_name')?$('.info').eq(j).children().children('.zhSecond_name').val():'',
                                        "identity_type":$(".Certificates option:selected").eq(j).index(),
                                        "id":$('.info').eq(j).children().children('.infoId')?$('.info').eq(j).children().children('.infoId').val():'',
                                      })
                                    }
                                    that.zanting=true
                                    //提交信息
                                    that.$ajax({
                                      method:"post",
                                      url:"/api/PlaceAnOrder",
                                      data:{
                                        "cid":that.id,
                                        "order_num":that.number,
                                        "name":contactName,
                                        "phone":contactPhone,
                                        "contact_id":contact_id,
                                        "is_scholarship":that.count,
                                        "scholarship":that.zhOrderList.scholarship,
                                        "source":4,
                                        "sign_user_info":chitList,
                                        "coupon":that.conid,
                                        "is_tuition":that.count1
                                      }

                                    })
                                      .then(function(data){
                                      	that.zanting=false
                                        if(data.data.error){
                                          alert(data.data.error.message)
                                        }else{
                                          that.$router.push({name:'audit',params:{id:that.id}})
                                        }

                                      })
                                  }else{
                                    a=true;
                                    b=true;
                                    c=true;
                                    d=true;
                                    e=true;
                                    f=true;
                                    alert("请填写完整信息")
                                  }

                                }else{
                                	  a=true;
	                                  b=true;
	                                  c=true;
	                                  d=true;
	                                  e=true;
	                                  f=true;
                                      alert("请填写完整信息")
                                   }
                                }else{
                                  a=true;
                                  b=true;
                                  c=true;
                                  d=true;
                                  e=true;
                                  f=true;
                                   alert("请填写完整信息")
                                 }
                              }else{
                                a=true;
                                b=true;
                                c=true;
                                d=true;
                                e=true;
                                f=true;
                                alert("请填写完整信息")
                              }
                         }else{
                           a=true;
                           b=true;
                           c=true;
                           d=true;
                           e=true;
                           f=true;
                           alert("请填写完整信息")
                         }
                      }else{
                        a=true;
                        b=true;
                        c=true;
                        d=true;
                        e=true;
                        f=true;
                        alert("请填写完整信息")
                     }

                   }else{
                        alert("请阅读并同意《报名须知》")
                    }
        },
        zhxieyi:function(){
          alert('报名须知\n一、报名流程\n1、【报名审核】学员提交报名申请后，以诺教育会在24小时内（包含节假日）审核您的报名资格，并短信通知您审核结果（注：本课程暂不接受5周岁以下、75周岁以上学员报名）；\n2、【付款期限】审核通过后，不涉及签证的课程请您在24小时内完成付款；涉及签证的课程，会有课程项目负责老师和您联系，协助您办理签证，并确定最晚付款日期。在付款日期确认完毕后，请您务必在付款截止日前完成付款；如您未按要求及时付清相关费用，则报名订单自动取消。出发前3周内仅接受已有目的地签证学员的报名；\n3、【学前准备】完成付款后，本期课程带班老师会在三个工作日内（节假日除外）和您联系，协助您办理各项入学手续。\n二、免责声明\n1、【信息真实】报名表中请如实填写公司和职位，如隐瞒真实职业背景，以诺教育有权取消其学员资格，且不承担任何违约责任；\n2、【展业限制】学习期间禁止学员之间借机推销、直销产品等，如因违反前述禁止事项，以诺教育有权将取消其学员资格，且不承担任何违约责任；\n3、【行程变更】网上公布行程仅供参考，在出发前或旅行期间，因不可抗力（如天气、天灾、战争、罢工等）因素以诺教育对具体行程进行适当变更，就此种情况下的行程变更，以诺教育不承担任何违约责任；\n4、【人身安全】外出访学请自觉遵守《中国公民旅游文明行为公约》、《中国公民出境旅游文明行为指南》，如因自身原因致使自身或他人人身、财产权益受到损害的，以诺教育不承担赔偿责任；若因此对本司造成损失的，还应对本司承担赔偿责任；如因学员自身健康及意识性错误导致的意外伤害事故，以诺教育免除一切经济赔偿责任。如因第三方责任造成的意外伤害事故，追偿事宜由学员自行办理；\n5、【保险购买】建议学员自行购买保险。如因个人原因放弃投保而产生的风险和损失将由学员自行承担。')
        },
        selected(coupon,index){
        	var that=this
        	if(that.conid.indexOf(coupon.id)==-1){
        		that.conid.push(coupon.id)
        	}
        	that.$ajax({
			  	method:"post",
			  	url:"/api/orderCouponGet",
			  	data:{cid:that.id,order_places:that.number,coupon:that.conid}
			  }).then(function(data){
			  	var arr1=[];
			  	var arr2=[];
			  	data.data.result.map((item,index)=>{
			  		if(item.useaccess==1){
			  			arr1.push(item);
			  		}else if(item.useaccess==0){
			  			arr2.push(item);
			  		}
			  	})
			  	var index1;
			  	[...arr1,...arr2].map((it,ind)=>{
			  		if(it.id==coupon.id){
			  			index1=ind;
			  		}
			  	})
			  	$(".Marquee").eq(index1).css({"display":"block"})
				that.conpons=[...arr1,...arr2];
			  }).catch(function(err){
			  	console.log(err)
			  })
        	that.$ajax({
                method:"post",
                url:"/api/ConfirmOrder",
                params:{"cid":that.id,"order_num":that.number,"is_scholarship":0,coupon:that.conid,is_tuition:that.count1},
                })
                .then(function(data){
            	that.zhOrderList=data.data.result;
              })
        },
        quxiao(coupon,index){
        	var that=this
 			var suoyin=that.conid.indexOf(coupon.id)
 			that.conid.splice(suoyin,1)
        	that.$ajax({
			  	method:"post",
			  	url:"/api/orderCouponGet",
			  	data:{cid:that.id,order_places:that.number,coupon:that.conid}
			  }).then(function(data){
				that.conpons=data.data.result
			  }).catch(function(err){
			  	console.log(err)
			  })
			  that.$ajax({
                method:"post",
                url:"/api/ConfirmOrder",
                params:{"cid":that.id,"order_num":that.number,"is_scholarship":0,coupon:that.conid,is_tuition:that.count1},
                })
                .then(function(data){
            	that.zhOrderList=data.data.result;
            	$(".Marquee").eq(index).css({"display":"none"})
              })
       },
        xuefei(){
        	var that=this
        	if(that.zhtoggleX==false){
        		that.count1=0
        		that.zhtoggleX=true
        		that.$ajax({
                method:"post",
                url:"/api/ConfirmOrder",
                params:{"cid":that.id,"order_num":that.number,"is_scholarship":that.count,coupon:that.conid,is_tuition:that.count1},
                })
                .then(function(data){
            	 that.zhOrderList=data.data.result;
              })
        	}else{
        		that.zhtoggleX=false
        		that.count1=1
        		that.$ajax({
                method:"post",
                url:"/api/ConfirmOrder",
                params:{"cid":that.id,"order_num":that.number,"is_scholarship":that.count,coupon:that.conid,is_tuition:that.count1},
                })
                .then(function(data){
            	 that.zhOrderList=data.data.result;
              })
        	}
        },
		},
		created(){
			var that=this
			//-----------------初始化  >>  优惠券----------------
	  that.$ajax({
	  	method:"post",
	  	url:"/api/orderCouponGet",
	  	data:{cid:that.id,order_places:that.number,coupon:[]}
	  }).then(function(data){
	  	that.conpons=data.data.result
	  }).catch(function(err){
	  	console.log(err)
	  })
		},
		mounted(){

			var that=this
      this.$ajax({
       method:"get",
       url:"/api/user_students",
       }).then(function(data){
         let studentsList=data.data.data;
         for(let i = 0;i<studentsList.length;i++){
           studentsList[i].display = false
         }
         that.studentsList = studentsList
       }).catch(function(err){
         console.log(err)
       })
       this.$ajax({
        method:"get",
        url:"/api/user_contacts",
        }).then(function(data){
          if(data.data.data.length===0){

          }else{
            that.linkmanLis = data.data.data[0]
          }
        }).catch(function(err){
          console.log(err)
        })
      //-----------验证---------
      //姓名
        $(document).on('change','.addName',function(){
          var reg_name = /^[\u4e00-\u9fa5]{2,5}$/
          if (!reg_name.test($(this).val())) {
              $(this).next().html('*请输入2—5字中文姓名！');
              $(this).focus();
              return false;
          }else{
            $(this).next().html('');
          }
        })
      //身份证
      $(document).on('change','.identity',function(){
      	for(let i=0;i<$(".Certificates").length;i++){
      		if($(".Certificates option:selected").eq(i).val()=="身份证"){
          var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if(!reg.test($(this).val()))
          {
          $(this).next().html('*身份证输入不合法！');
        }else{
           $(this).next().html('');
         }
        }else{
          if($(this).val()=="")
          {
          $(this).next().html('*输入不能为空！');
        }else{
           $(this).next().html('');
        }
      		}
      	}

      })
   	//海外证件号检测
   	  $(document).on("change",'.Certificates',function(){
   	  	  for(let i=0;i<$(".Certificates").length;i++){
   	  	  	if($(".Certificates option:selected").eq(i).val()=="护照"){
   	  	  		$(".oversea").eq(i).css({"display":"none"})
   	  	  	}else{
   	  	  		$(".oversea").eq(i).css({"display":"block"})
   	  	  	}
   	  	  }
   	  })
      //手机号
      $(document).on('change','.phone',function(){
        if(!(/^1\d{10}$/.test($(this).val()))){
              $(this).next().html('*手机号码有误，请重填！');
              return false;
        }else{
           $(this).next().html('');
         }
      })
       //护照
      $(document).on('change','.passport',function(){
      	if(that.interval==1){
        if($(this).val()===''){
              $(this).next().html('*请填写内容！');
              return false;
        }else{
           $(this).next().html('');
         }
        }
      })
    //名字拼音
    $(document).on('change','.zhFight',function(){
        if($(this).val()===''){
          $(".error1").html('*请填写内容！');
        }else{
          $(".error1").html('');
         }
      })


		//--------------点击添加-----------------
			$(document).on("click",".add",function(index){
        // console.log(index)
        if(that.number>=5){
          return
        }
        var src  = '<div class="info"><div class="people"><span>1</span></div><p v-if=""><span>姓名</span><input type="text" class="addName"/><i class="error"></i></p><p><span>护照英文姓</span><input type="text" class="zhFight"/><span class="zhPin">护照英文名</span><input type="text" class="zhFight zhSecond_name"/><i class="error1"></i></p><p class="zhSpecial"><span class="zhP">证件号码</span><select class="Certificates"><option selected="selected">身份证</option><option>护照</option><option>台胞证</option><option>回乡证</option></select><input type="text" class="identity" /><i class="error"></i></p><p v-if="zhOverseas" class="oversea"><span>护照号</span><input type="text" class="zhPassportHZ"/><i class="error"></i></p>  <p class="zhSpecial" v-if="zhOverseas"><span class="zhP">护照有效期</span><Col span="8"><DatePicker type="date" placeholder="Select date" style="width: 200px"></DatePicker></Col><i class="error"></i></p><p><span>手机</span><input type="text" class="phone"/><i class="error"></i></p><p class="zhSpecial renzhi"><span class="zhP">任职机构</span><input type="text" class="passport zhPassport1"/><i class="error"></i></p><p class="zhiwu"><span>职务</span><input type="text" class="passport zhJigou"/><i class="error"></i></p><p><input class="infoId" type="hidden"></p><div class="delate" ><span>－</span>删除</div></div>'
        var src1  = '<div class="info"><div class="people"><span>1</span></div><p><span>姓名</span><input type="text" class="addName"/><i class="error"></i></p><p class="zhSpecial"><span class="zhP">证件号码</span><select class="Certificates"><option selected="selected">身份证</option><option>护照</option><option>台胞证</option><option>回乡证</option></select><input type="text" class="identity" /><i class="error"></i></p><p><span>手机</span><input type="text" class="phone"/><i class="error"></i></p><p class="zhSpecial renzhi"><span class="zhP">任职机构</span><input type="text" class="passport zhPassport1"/><i class="error"></i></p><p class="zhiwu"><span>职务</span><input type="text" class="passport zhJigou"/><i class="error"></i></p><p><input class="infoId" type="hidden"></p><div class="delate" ><span>－</span>删除</div></div>'
        that.number++;
        if(that.zhOverseas == false){

          that.ceshi.push(that.number)
          // $(src1).appendTo("#add")
        }else{
          that.ceshi.push(that.number)
          // $(src).appendTo("#add")
        }

        for(var i=0;i < $(".info").length;i++){
           $(".info").eq(i).children(".people").children().html(i+1)
           if(that.interval==0){
           		$('.info').eq(i).children('.renzhi').css({"display":"none"})
           	 	$('.info').eq(i).children('.zhiwu').css({"display":"none"})
           }else{
           		$('.info').eq(i).children('.renzhi').css({"display":"block"})
            	$('.info').eq(i).children('.zhiwu').css({"display":"block"})
           }

        }
        that.conid=[]
        $(".Marquee").css({"display":"none"})
        that.$ajax({
                method:"post",
                url:"/api/ConfirmOrder",
                params:{"cid":that.id,"order_num":that.number,"is_scholarship":0,coupon:that.conid,is_tuition:that.count1},
                })
                .then(function(data){
            	that.zhOrderList=data.data.result;
              })
                /*---------------------------优惠券-----------------------------*/
		that.$ajax({
			  	method:"post",
			  	url:"/api/orderCouponGet",
			  	data:{cid:that.id,order_places:that.number,coupon:that.conid}
			 }).then(function(data){
			  	that.conpons=data.data.result
			  }).catch(function(err){
			  	console.log(err)
			  })
			})

			//------------点击删除----------------
			$(document).on("click",".delate",function(){
				if($(".info").length > 1){
				    that.number--;
            let infoId = $(this).parent().children().children('.infoId').val()
            if(infoId ===''){
            }else{
              for(let i = 0;i < that.studentsList.length; i++){
                if(that.studentsList[i].id === parseInt(infoId)){
                  that.studentsList[i].display = false
                }
              }
            }
				    $(this).parent().remove()
				    for(var i=0;i < $(".info").length;i++){
              $(".info").eq(i).children(".people").children().html(i+1)
           }
			that.conid=[];
			$(".Marquee").css({"display":"none"})
           that.$ajax({
             method:"post",
              url:"/api/ConfirmOrder",
              params:{"cid":that.id,"order_num":that.number,"is_scholarship":0,coupon:that.conid,is_tuition:that.count1},
              })
              .then(function(data){
               that.zhOrderList=data.data.result;
            })
                      /*---------------------------优惠券-----------------------------*/
		that.$ajax({
			  	method:"post",
			  	url:"/api/orderCouponGet",
			  	data:{cid:that.id,order_places:that.number,coupon:that.conid}
			}).then(function(data){
			  	that.conpons=data.data.result
			  }).catch(function(err){
			  	console.log(err)
			  })
				}
			})

      //----------------------点击 奖学金 -----------------

      $('.jiang').on('click',function(){
        if(that.zhtoggle==false){
          that.zhtoggle=true;
          that.count = 0;
          that.$ajax({
              method:"post",
              url:"/api/ConfirmOrder",
              params:{"cid":that.id,"order_num":that.number,"is_scholarship":that.count,coupon:that.conid,is_tuition:that.count1},
              })
              .then(function(data){
              that.zhOrderList=data.data.result;
            })
        }else{
          that.zhtoggle=false;
          that.count = 1;
          that.$ajax({
              method:"post",
              url:"/api/ConfirmOrder",
              params:{"cid":that.id,"order_num":that.number,"is_scholarship":that.count,coupon:that.conid,is_tuition:that.count1},
              })
              .then(function(data){
              that.zhOrderList=data.data.result;
            })
        }
      })

      //----------------------点击 协议 -----------------

      $('.yue').on('click',function(){
        if(that.zhtoggle1==true){
          that.zhtoggle1=false;
        }else{
          that.zhtoggle1=true;
        }
      })

	     //-----------------初始化  >>  滑过----------------
       $(document).on("mousemove",".info",function(){
          $(this).children(".people").css({"background":"#11cc99"})
         if(that.number==1){
            $(".delate").css({"display":"none"})
           }else{
           $(this).children(".delate").css({"display":"block"})
         }
           })
          $(document).on("mouseleave",".info",function(){
          	$(this).children(".people").css({"background":"#d6d9e6"})
 			$(this).children(".delate").css({"display":"none"})
         })


      //-----------------初始化  >>  课程详情----------------
          that.$ajax({
            method:"post",
            url:"/api/classesDetailGet",
            params:{"id":that.id},
          }).then(function(data){
			     that.list=data.data.result
          }).catch(function(err){
          		console.log(err)
          })

       //-----------------初始化  >>  确认订单----------------
			that.$ajax({
        method:"post",
        url:"/api/ConfirmOrder",
        params:{"cid":that.id,"order_num":1,"is_scholarship":0,is_tuition:1},
      }).then(function(data){
      	that.interval=data.data.result.survey
      	that.img=data.data.result.img_url
        //修改
        that.zhOrderList=data.data.result;
         if(data.data.result.internal == 1){
            //1是海外
           that.zhOverseas = true;
           that.pinyin=true
//         $(".pinin").css({"display":"block"})
        }else{
           that.zhOverseas = false;
           that.pinyin=false
//         $(".pinin").css({"display":"none"})
         }
        //-----------判断级别-------------------
        if(data.data.result.preferential_switch==0){
        	that.scholarship=false
        	that.coupon=false
        	that.couponValue=false
        	that.count=1
        }else{
        	that.scholarship=true
        	that.coupon=true
        	that.couponValue=true
        }
      }).catch(function(err){
      		console.log(err)
      })
		//-----------------初始化  >>  图片----------------
//		 that.$ajax({
//          method:"post",
//          url:"/api/ConfirmOrder",
//        	params:{"cid":that.id ,"order_num":5,"is_scholarship":0},
//         }).then(function(data){
//			     that.img=data.data.result.img_url
//        }).catch(function(err){
//        		console.log(err)
//        })
      //新加
      $(document).on("focus","input.ivu-input",function(){
        $("input.ivu-input").css({"box-shadow":"0 0 15px rgba(0,0,0,0)"})
    })
    $(document).on("mousemove","input.ivu-input",function(){
        $("input.ivu-input").css({"border":"1px solid #DFDFDF"})
    })
    if(localStorage.getItem("token")==null){
    	$(".backdrop").css({"display":"block"})
    }else{
    	$(".backdrop").css({"display":"none"})
    }
    //初始化刷新
      if(that.xin==1){
      	 sessionStorage.setItem("xin",0)
      	 location.reload()
      }
	 }

	}
</script>

<style>
  #add{width:782px;}
  .order{width:100%;background:#f4f5f9;overflow: hidden;}
  .orderA{width:1165px;height:100%;margin:0 auto;position: relative;padding-bottom: 235px;}
  /*-------------------------------------悬浮框--------------------------------------------*/
  .cost{position:fixed;width:300px;min-height:260px;background:#fff;margin:30px 0 0 857px;color:#4F4F4F;box-shadow:0 0 15px rgba(0,0,0,.08);}
  .detail{font-size: 20px;margin:28px;}
  .detailText{width:242px;margin-left:30px;border-bottom:1px solid #e6e6e6;}
  .detailText li{margin-bottom:19px;}
  .detailText>li>span{float:right;font-size: 18px;}
  .money1{width:242px;margin:18px 0 20px 30px;}
  .money1>span{float:right;font-size: 24px;color:#01b784;}
  .integral{font-weight: 100;margin-left: 10px;}
  /*-------------------------------------订单状态--------------------------------------------*/
  .flow{width:842px;height:125px;background:url(../../assets/jindutiao.png) no-repeat 70px 40px;}
  /*-------------------------------------课程详情--------------------------------------------*/
  .orderHader{width:842px;height:160px;background:#fff;}
  .headerLeft{float:left;width:260px;height:160px;}
  .headerLeft img{width:200px;height:100px;margin:30px;}
  .headerRight{float:left;width:582px;height:160px;}
  .article{font-size:20px;font-weight:100;margin-top:40px;color:#4f4f4f;}
  .address{margin-top:20px;}
  .headerRight p{line-height:24px;color:#909090;}
  /*-------------------------------------学员信息--------------------------------------------*/
  .content{width:842px;height:100%;margin-top:20px;background:#fff;margin-bottom:30px;}
  .student{margin-left:30px;width:782px;border-bottom:2px solid #11cc99;color:#909090;line-height: 46px;margin-top:10px;font-size: 14px;display: flex;align-items: center;}
  .student b{font-size: 18px;margin-right:15px;color:#4f4f4f;}
  .student>.renshuo{color:#ff5050;font-size: 18px;font-weight: 900;}
  .student .yes-up {display: flex;align-items: center;margin-left: 400px;cursor: pointer;}
  .student .yes-up img{width: 20px;height: 20px;}
  .student .yes-up span{margin-left: 15px;color: #11cc99;font-size: 14px;font-weight: bold;}
  .info-choice{width:782px;margin-left:30px;border-bottom:1px solid #f0f0f0;position:relative;padding-top: 30px;padding-bottom: 30px;display: flex;flex-wrap: wrap;padding-left:30px}
  .info-choice li{width: 100px;height: 50px;border-color: #11cc99;color: #FFFFFF;line-height: 50px;text-align: center;margin-right: 50px;background-color: #11cc99;font-size: 18px;margin-top: 30px}
  .info-choice li:nth-child(1){margin-left: 0px;}
  .info-choice  .ceshi{background:none;border:1px solid #11cc99;color: #11cc99}
  .info-message{width:782px;margin-left:30px;border-bottom:1px solid #f0f0f0;position:relative;padding-top: 30px;padding-bottom: 30px;padding-left: 15px;display: flex;align-items: center;}
  .info-message .delates{width: 25px;height: 25px;border-radius:25px;background-color: #d6d9e6;text-align: center;display: flex;align-items: center;justify-content: center;}
  .info-message .delates hr{width:12px;border: 1px solid #FFFFFF;}
  .info-message .details{display: flex;flex-direction: column;margin-left: 30px;}
  .info{width:782px;margin-left:30px;border-bottom:1px solid #f0f0f0;position:relative;margin-top:15px;}
  .people{width:40px;height:40px;border-radius: 50%;background:#d6d9e6;text-align: center;position:absolute;left:10px;top:30px;}
  .people span{line-height: 40px;font-size: 24px;font-family: arial;color:#fff;}
  .info p input{width:200px;height:30px;border:1px solid #dfdfdf;margin-left:20px;}
  .info p>span{width:70px;display:inline-block;text-align: right;color:#4f4f4f;}
  .info p{line-height:50px;margin-left:90px;}
  .delate{width:60px;height:20px;color:#ff5050;position:absolute;top:20px;right:60px;cursor:pointer;}
  .delate span{width:16px;line-height:16px;border-radius: 50%;display:inline-block;background:#fff;text-align: center;border:1px solid #ff5050;margin-right:10px;}
  .addstu{cursor:pointer;width:160px;line-height:36px;background:#fff;border:1px solid #01b784;border-radius: 5px;margin:20px 15px 0 180px;float: left;color:#01b784;font-size: 14px;display: flex;align-items: center;justify-content: center;text-align: center;}
  .addstu span{font-size:24px;font-weight: 600;}
  .add p{float: left;margin-top:20px;line-height:36px;}
  .kong{clear: both;}
  .contact{width:100%;height:195px;margin-top:34px;color:#4f4f4f;}
  .contact p span{width:45px;text-align: right;display: inline-block;}
  .contact p input{width:200px;height:30px;border:1px solid #dfdfdf;margin-left:18px;}
  .tt1{margin:30px 0 18px 90px;}
  .tt2{margin-left:90px;}
  .contactText{width:782px;line-height:48px;font-size: 18px;font-weight: 900;margin-left:30px;border-bottom:2px solid #11cc99;display: flex;align-items: center;}
  .contactText .yes-up {display: flex;align-items: center;width: auto;margin-left: 460px;cursor: pointer;}
  .contactText .yes-up img{width: 20px;height: 20px;}
  .contactText .yes-up span{width: auto;;margin-left: 15px;color: #11cc99;font-size: 14px;}
  .error{color:#ff5050;margin-left:10px;font-style:normal;}
  .error1{color:#ff5050;margin-left:10px;font-style:normal;}
  /*-------------------------------------联系您--------------------------------------------*/
  .chit{width:100%;padding-bottom: 48px;}
  .chitCon{width:782px;line-height:48px;margin-left:30px;font-size: 18px;font-weight: 900;border-bottom:2px solid #11CC99;}
  .chitNum{margin:30px 0 0 90px;}
  .chitNum span{width:45px;display:inline-block;text-align: right;}
  .chitPh{width:200px;height:30px;margin-left:18px;border:1px solid #dfdfdf;}
  /*-------------------------------------推荐人信息--------------------------------------------*/
  .discount{min-height:143px;border-bottom:1px solid #d6d9e6;}
  .discountText{width:782px;line-height:48px;margin-left:30px;font-size: 18px;font-weight: 900;border-bottom:2px solid #11CC99;}
   /*-------------------------------------优惠信息--------------------------------------------*/
  .burse{margin:0 0 0 30px;color:#4f4f4f;width: 760px;height: 95px;border-top:1px solid #eeeeee;}
  .jiang{width:20px;height:20px;line-height:20px;border:1px solid #dfdfdf;background:#fff;font-size: 18px;text-align: center;margin:3px 10px;color:#11cc99;}
  .xue{width:20px;height:20px;line-height:20px;border:1px solid #dfdfdf;background:#fff;font-size: 18px;text-align: center;margin:3px 10px;color:#11cc99;}
  .burse li{float: left;margin-top:30px;}
  .qian{width:120px;line-height:30px;border:1px solid #dfdfdf;margin:0 15px 0 30px;padding-left:10px;}
  .shuo{color:#909090;}
  /*---------------------------------------优惠券----------------------------------------------------*/
 	.couponValue{border-bottom:1px solid #d6d9e6;min-height: 100px;}
 	.voucher{margin:30px 0 20px 40px;color: #4f4f4f;font-size: 16px;}
 	.voucher span{color: #909090;font-size: 14px;}
 	.couponPicture{width:345px;height:125px;background:url(../../assets/youhui1.png)no-repeat -16px -6px;margin:0 0 30px 40px;float: left;position: relative;}
 	.mask{width: 345px;height: 125px;position: absolute;top: 0;z-index: 102;background: rgba(255,255,255,0);display: none;}
 	.couponPicture1{width:345px;height:125px;background:url(../../assets/youhui2.png)no-repeat -16px -6px;margin:0 0 30px 40px;float: left;}
 	.received{background: url(../../assets/youhui2.png)no-repeat -16px -6px;}
 	.VouchersLeft1{width:345px;height:125px;}
   .amountNumbert{padding:24px 0 12px 24px;color: #fff;}
   .amountNumbert span{font-size: 24px;font-weight: 600;}
   .amountNumbert i{font-style: normal;margin-left:16px;}
   .moneyTime{margin-left: 24px;color: #a8ebe8;}
   .VouchersLeft1 .Voucher{color: #bbbbbb;}
   .Marquee{width:345px;height:125px;background: url(../../assets/gouxuan.png)no-repeat;position: absolute;top:0;display: none;z-index: 105;}
   .CancelCheck{width: 80px;line-height:30px;float: right;background:#d5f6ee;margin:4px 3px 0 0;text-align: center;color: #0077ee;cursor: pointer;}
   /*-------------------------------------底部信息--------------------------------------------*/
  .agree{height:90px;margin-bottom:30px;}
  .read{margin:25px 0 0 30px;color:#4f4f4f;}
  .read li{float:left;line-height:40px;}
  .read .zhxieyi{text-decoration: none;color:#01b784;}
  .yue{width:20px;height:20px;line-height:20px;border:1px solid #dfdfdf;background:#fff;font-size: 18px;text-align: center;margin:10px;color:#11cc99;}
  .paid{margin-left:180px;}
  .paid span{color:#01b784;font-size: 24px;}
  .zhCommit{cursor:pointer;width:160px;height:40px;background:#11cc99;border-radius: 5px;border:none;margin-left:35px;text-align: center;color:#fff;display: block;}
  .zhCommit:hover{text-decoration: none;color:#fff;}
  .toggle{display:none}
  /*新加样式*/
  .zhPin{margin-left:20px;}
  .info .zhSpecial{margin-left:60px;}
  .info p .zhP{width:80px;float:left;margin-left: 20px}
  .ivu-input-icon-normal+.ivu-input{float:left;border-radius: 0;}
  .ivu-input-icon-normal+.ivu-input:hover{border:1px solid #DFDFDF;}
  .ivu-col-span-12 {  width: 80%;margin-right:50px;}
  .ivu-input-icon{right:-20px;}
  .order input{padding-left:10px;}
  .bitian{line-height: 48px;font-size: 14px;font-weight: 500;color:#909090;}
  .content input{line-height: 30px;}
  .order input::-webkit-input-placeholder{color: #d5d5d5;opacity:1;}
  .jiacu{font-weight: 900;}
  .pinin{display:block;}
  .Certificates{height: 30px;border:1px solid #dfdfdf;margin-left: 20px;}
  .ivu-select-dropdown{left: 20px !important}
  .ivu-date-picker-cells-cell-today em:after{background-color: #11cc99 !important}
  .ivu-input-wrapper i{right: -25px !important}
</style>



// WEBPACK FOOTER //
// order.vue?5c2a4cf8